import type { FaireProductEntity } from "../../entity_types/product";

export const p_vgq5x8ec86: FaireProductEntity = {
  token: "p_vgq5x8ec86",
  type: "product",
  name: "Solid Color Tailored Blazer",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Aria Romance",
  imageUrl:
    "https://cdn.faire.com/fastly/3b1ce32167562daf3d0f30e85e41a80d3f4a2bcc71a925cff0198e1f1a865cc2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/044b01bd96ca9949f69503e32f2b46c3c42f0139ccb50fad9ac0b824094ff18b.jpeg",
    "https://cdn.faire.com/fastly/ff71a6d89e51520c4d5576a818a01ad42b8dcb47f2996d423069c4b3a1d56cc4.jpeg",
    "https://cdn.faire.com/fastly/8526d5252eac7bcf31380b1f25d0c8752cd59f9b208b4eea2129baa826f0a5d7.jpeg",
    "https://cdn.faire.com/fastly/56f843dcfe4eee8a92868fd4b095debd1db880270fc98e495fc3a91d74fc3be3.jpeg",
    "https://cdn.faire.com/fastly/10f5fd476b09633d5c0d71c8a4618eef1a443a9a56e9936df4bf0cb6d9ce552a.jpeg",
    "https://cdn.faire.com/fastly/52f651cc5a6ac50d587c17edce4aded39f194df5291578297cc7e9a5ab1cdfcb.jpeg",
    "https://cdn.faire.com/fastly/04480a032ab61ce6c5bc70a971e8d1d7b4a249acfcecd6cb8cd71c9bc5775a8d.jpeg",
    "https://cdn.faire.com/fastly/288c8589b3d23328d43993079750f37844b12c020223eb9d594744ef3c4c3bc2.jpeg",
    "https://cdn.faire.com/fastly/5a269b91020335f732fdbdf2b418f8a5ee09c6a1d21a0d40ec2f89c0081cc1ce.jpeg",
    "https://cdn.faire.com/fastly/b76eb5814e3814228db2700a43d43c5a59abbf205ecb68264d3a691b210d234f.jpeg",
    "https://cdn.faire.com/fastly/d23c2f61957fc4da4e0f2950c43c65ab674597a377e0b491bc6121bbf14e4121.jpeg",
    "https://cdn.faire.com/fastly/5581818df0442fe8bfa199780e22c1eb03b004043761a83972454bcd66345e12.jpeg",
    "https://cdn.faire.com/fastly/7193dd3bbe85005d62f60956a42925616181bb0e1f2d57df154101b32880a0e7.jpeg",
    "https://cdn.faire.com/fastly/ecb8c91a8fc17514336fb65abd223f554dba384a8a431a61a6876bb706359d38.jpeg",
    "https://cdn.faire.com/fastly/c09874a1bdb10b0ddf8f5dad6086806df06978e5b302ef0d0a1fee565373a9c2.jpeg",
    "https://cdn.faire.com/fastly/e19e81f2a34ed5be4fb87899a6bf9f176dab9eb4f626b440815830cc4bcd6977.jpeg",
    "https://cdn.faire.com/fastly/737086705167e8a778f84d4e043694525edd653fc8900d6b599a069df6e513d3.jpeg",
    "https://cdn.faire.com/fastly/7e6c69be898411917dced955040d5fe7b9b479a015cacdf8cced236b75620ddf.jpeg",
    "https://cdn.faire.com/fastly/68ac92ced6c26665548b73b567e0c01057d444b0e7f965c9889d0f82ec418bde.jpeg",
    "https://cdn.faire.com/fastly/cb6afc190899a54c2ce8c3e3be84e9f59448f9547fae91c38786f0f124cba846.png",
  ],
  priceDollars: 39.48,
  description:
    "ACHIEVE A POLISHED AND PROFESSIONAL LOOK WITH THIS SOPHISTICATED BLAZER, FEATURING A CLASSIC TAILORED SILHOUETTE AND A SMOOTH, STRUCTURED DRAPE.\n\nIMPORTED, DESIGNED IN USA\n\nTAILORED BLAZER WITH DEFINED LAPELS\n\nSMOOTH FABRIC WITH EXCELLENT DRAPE\n\nCONT 90% POLYESTER 10% VISCOSE\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nPlease note: This product ships from China. We cover all customs and import duties for you! Delivery takes 4-5 business days after your order ships. Please contact us if you have any questions.",
  tags: [],
  msrpDollars: 74.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:50.313Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
